import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import API from '../../utils/ApiConfig';
import { AUTOMATED_ONBOARDING_PAGE } from '../../utils/ApiEndpoints';
import Loader from '../common/Loader/Loader';
import {
  AUTOONBOARD_NAVIGATION_TYPE_BACK,
  AUTOONBOARD_NAVIGATION_TYPE_NEXT,
  AUTOONBOARD_SAVE_TYPE_SAVE_COMPLETE,
  AUTOONBOARD_SAVE_TYPE_SAVE_ONLY,
} from '../../utils/AutoOnboardConfig';

const AutomatedOnboardingFooter = props => {
  const { commonProps, pageInitialized, onNavigationError, onDataSaveNotification } = props;
  const {
    services: { CommonService },
  } = commonProps;
  const {
    btnInfo: { backBtn, nextBtn, saveBtn, saveExitBtn, createBudgetBtn },
  } = props;

  const [isLoading, setLoading] = useState(false);

  const { t } = useTranslation();
  const tc = (e, data) => (data ? t(`autoonboard_common:${e}`, data) : t(`autoonboard_common:${e}`));

  const isAutoOnboardingWithoutSampleBudgetEnabled = CommonService.isAutoOnboardingWithoutSampleBudgetEnabled;

  const handleSaveBtnClick = () =>
    saveBtn.click(AUTOONBOARD_SAVE_TYPE_SAVE_ONLY, () => {
      onDataSaveNotification();
    });

  const handleSaveExitBtnClick = () =>
    saveExitBtn.click(AUTOONBOARD_SAVE_TYPE_SAVE_ONLY, () => {
      onDataSaveNotification();
      CommonService.auth.logout(CommonService.auth.getCurrentUser().id);
    });

  const handleBackBtnClick = () =>
    backBtn.click(AUTOONBOARD_SAVE_TYPE_SAVE_ONLY, () => {
      setLoading(true);
      API.put(AUTOMATED_ONBOARDING_PAGE, {
        navigateType: AUTOONBOARD_NAVIGATION_TYPE_BACK,
      })
        .then(() => {
          setLoading(false);
          let { onActiveStepChange, activeStep } = props;
          onActiveStepChange(--activeStep);
        })
        .catch(err => {
          setLoading(false);
          onNavigationError(err);
        });
    });

  const handleNextBtnClick = () =>
    nextBtn.click(AUTOONBOARD_SAVE_TYPE_SAVE_COMPLETE, () => {
      setLoading(true);
      API.put(AUTOMATED_ONBOARDING_PAGE, {
        navigateType: AUTOONBOARD_NAVIGATION_TYPE_NEXT,
      })
        .then(() => {
          setLoading(false);
          let { onActiveStepChange, activeStep } = props;
          onActiveStepChange(++activeStep);
        })
        .catch(err => {
          setLoading(false);
          onNavigationError(err);
        });
    });

  return (
    <Fragment>
      {isLoading && <Loader />}

      <div className="automated-onboarding-footer">
        <div className="navigation-buttons">
          {backBtn && backBtn.showBtn && (
            <button
              disabled={backBtn.disabled || !pageInitialized}
              style={{ marginRight: '10px' }}
              className="btn btn-primary"
              onClick={handleBackBtnClick}>
              <i className="fa fa-angle-left"></i> {tc('AUTOMATED_ONBOARDING_BUTTON_BACK')}
            </button>
          )}
          {nextBtn && nextBtn.showBtn && (
            <button disabled={nextBtn.disabled || !pageInitialized} className="btn btn-primary pm-next-button" onClick={handleNextBtnClick}>
              {tc('AUTOMATED_ONBOARDING_BUTTON_NEXT')} <i className="fa fa-angle-right"></i>
            </button>
          )}
          {createBudgetBtn && createBudgetBtn.showBtn && (
            <button
              disabled={createBudgetBtn.disabled || !pageInitialized}
              className="btn btn-primary pm-create-budget-button"
              onClick={createBudgetBtn.click}>
              {isAutoOnboardingWithoutSampleBudgetEnabled
                ? tc('AUTOMATED_ONBOARDING_CREATE_PLAN_BUTTON')
                : tc('AUTOMATED_ONBOARDING_CREATE_BUDGET_BUTTON')}
            </button>
          )}
        </div>
        <div className="save-buttons">
          <button
            disabled={saveBtn.disabled || !pageInitialized}
            style={{ marginRight: '10px' }}
            className="btn btn-primary btn-none-navigational"
            onClick={handleSaveBtnClick}>
            {tc('AUTOMATED_ONBOARDING_BUTTON_SAVE')}
          </button>
          <button disabled={saveExitBtn.disabled || !pageInitialized} className="btn btn-primary" onClick={handleSaveExitBtnClick}>
            {tc('AUTOMATED_ONBOARDING_BUTTON_SAVELOGOUT')}
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default AutomatedOnboardingFooter;